import styled from 'styled-components';

export const LotesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const LoteCard = styled.div`
  border: 1px solid #dcecec;
  border-radius: 4px;
  overflow: hidden;
`;

export const LoteHeaderButton = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0.85rem 1rem;
  background-color: #f4f8fa;
  border: none;
  cursor: pointer;
  text-align: left;
  flex-wrap: wrap;

  .title {
    font-weight: bold;
    color: #084ca4;
    font-size: 1.8rem;
  }

  .right {
    display: flex;
    align-items: center;
    gap: 0.75rem;
  }
`;

export const LoteTotal = styled.span`
  font-weight: bold;
  font-size: 1.4rem;
`;

export const Chevron = styled.span`
  color: #084ca4;
  font-size: 1.6rem;
  transition: transform 0.2s ease;

  &.open {
    transform: rotate(180deg);
  }
`;

export const ItensTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 1.2rem;

  th,
  td {
    text-align: left;
    padding: 0.6rem 1rem;
    border-bottom: 1px solid #eef2f4;
  }

  th {
    background-color: #dee8ed;
    font-weight: bold;
  }
`;

export const EmptyState = styled.p`
  color: #666;
  font-size: 0.95rem;
  padding: 0.85rem 1rem;
`;
